import { sha256 } from '@noble/hashes/sha2';
import { bytesToHex } from '@noble/hashes/utils';
// ---------------------------------------------------------------------------
// Identity contract (ported from the daemon's schema.ts — must stay bit-compatible
// so item ids computed by the daemon match ids computed here on import).
// ---------------------------------------------------------------------------
// Feedback attaches to assistant-level "tracks", not raw source objects.
// item_id = "itm_" + sha256(namespace + source_type + source_ref + semantic_slot)
export const ITEM_ID_NAMESPACE = 'langston-assistant:v1';
export const ITEM_ID_RE = /^itm_[0-9a-f]{40}$/u;
// note_id = "note_" + 24 hex chars (server-minted on create).
export const NOTE_ID_RE = /^note_[0-9a-f]{24}$/u;
export const TODO_ID_RE = /^todo_[0-9a-f]{24}$/u;
export const TODO_PROPOSAL_ID_RE = /^tdp_[0-9a-f]{24}$/u;
/**
 * Compute the stable, content-addressed id for a feedback-capable item.
 *
 * Isomorphic (browser + node): uses @noble/hashes rather than node:crypto so the
 * contracts package can be imported by the SPA bundle. Produces the identical
 * digest to the daemon's `createHash('sha256').update(...).digest('hex')` because
 * both hash the utf-8 bytes of the same NUL-joined string.
 */
export function computeItemId(params) {
    const namespace = params.namespace ?? ITEM_ID_NAMESPACE;
    const input = [namespace, params.source_type, params.source_ref, params.semantic_slot].join('\0');
    const hash = bytesToHex(sha256(new TextEncoder().encode(input)));
    return `itm_${hash.slice(0, 40)}`;
}
